import { render } from "./FiltroCategorias.vue?vue&type=template&id=e4eda750&scoped=true"
import script from "./FiltroCategorias.vue?vue&type=script&lang=js"
export * from "./FiltroCategorias.vue?vue&type=script&lang=js"

import "./FiltroCategorias.vue?vue&type=style&index=0&id=e4eda750&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4eda750"]])

export default __exports__